/**
 * Оборачивает URL в `url("...")` для CSS `background-image`.
 * Экранирует `"` и `\`, чтобы значение нельзя было вырваться из функции `url()` (CSS-инъекция).
 */
export const toCssImageUrl = (imageUrl: string): string => `url("${imageUrl.replace(/(["\\])/g, '\\$1')}")`;
